import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { motion } from 'framer-motion';
import { staggerParent, staggerItem } from '../lib/motion';

const PaymentCancel = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <motion.div
      variants={staggerParent(0.12)} initial="hidden" animate="show"
      className="max-w-xl mx-auto px-6 py-28 sm:py-36 text-center" data-testid="payment-cancel-page">
      <motion.div variants={staggerItem}>
        <ShoppingBag size={48} className="text-[#c6a15b] mx-auto mb-6 pop-in" />
      </motion.div>
      <motion.h1 variants={staggerItem} className="font-display text-5xl text-[#1a1a1a] mb-3">Checkout cancelled</motion.h1>
      <motion.p variants={staggerItem} className="font-body text-[#6b6459] mb-8">No worries — your bag is saved. You can pick up right where you left off whenever you're ready.</motion.p>
      <motion.div variants={staggerItem} className="flex flex-wrap gap-4 justify-center">
        <Link to="/cart" className="btn-gold inline-block px-9 py-4"><span>Back to Bag</span></Link>
        <Link to="/shop" className="px-9 py-4 border border-[#0b0b0b] text-[#0b0b0b] overline text-xs hover:bg-[#0b0b0b] hover:text-[#e7d3a1] transition-colors">Continue Shopping</Link>
      </motion.div>
    </motion.div>
  );
};

export default PaymentCancel;
